import { Injectable } from "@angular/core";
import { ErrorInterceptor } from "./ErrorInterceptor";
import { HttpClient } from "@angular/common/http";


declare let ENDPOINT_LUDYAPI: string;
declare let NAMESPACE_LUDYACCOUNT: string;

@Injectable()
export class OptionsHttp {

    constructor(private http: HttpClient,
        private errorInterceptor: ErrorInterceptor) {

    }

    getOptions(param?): Promise<any> {
        param = !param ? {} : param;
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "app/modules";
        let request = this.http.put(url,param);

        return new Promise((resolve, reject) => {
            request.subscribe((response:any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }

    getDinamicOptions(param?): Promise<any> {
        param = !param ? {} : param;
        let url: string = ENDPOINT_LUDYAPI + NAMESPACE_LUDYACCOUNT + "system/user/menu";
        let request = this.http.put(url,param);

        return new Promise((resolve, reject) => {
            request.subscribe((response:any) => {
                resolve(response);
            }, (error) => {
                reject(this.errorInterceptor.handleError(error));
            });
        });
    }
}

